import { Box, TextField } from "@mui/material";
import { Contact, DepartmentInformation } from "@repo/server-api";
import { useTranslation } from "next-i18next";
import React, { useState, useEffect, useImperativeHandle, forwardRef, useCallback } from "react";
import * as Yup from "yup";

import Loader from "@repo/legacy/components/shared/Loader";

const DepartmentInfo = forwardRef(
	(
		props: Readonly<{
			contact?: Contact | null;
			setContact?: (value: Contact) => void;
			errors?: Record<string, string | boolean | object>;
			setErrors?: (value: Record<string, boolean | string | object>) => void;
			isLoaded?: boolean;
		}>,
		ref: React.Ref<{
			validate: () => Promise<Record<string, boolean | object | string>>;
		}>,
	) => {
		const { t } = useTranslation();

		const [info, setInfo] = useState<DepartmentInformation>({
			id: "",
			__typename: "DepartmentInformation",
			departmentName: "",
		});

		const [isLoaded, setIsLoaded] = useState<boolean>(false);

		const validationSchema = Yup.object().shape({
			// departmentName: Yup.string().required(t("validation.department.required")),
		});

		useEffect(() => {
			if (props.contact && !isLoaded) {
				const departmentInfo = props.contact.additionalInformation?.find(
					(info): info is DepartmentInformation =>
						(info as DepartmentInformation).__typename === "DepartmentInformation",
				) ?? {
					id: "",
					__typename: "DepartmentInformation",
					departmentName: "",
				};
				setInfo(departmentInfo);
				setIsLoaded(true);
			}
		}, [props.contact, props.isLoaded, isLoaded]);

		useImperativeHandle(ref, () => ({
			validate: validateFields,
		}));

		const validateFields = useCallback(async () => {
			const localErrors: Record<string, boolean | object | string> = {};
			try {
				await validationSchema.validate(info, { abortEarly: false });
				props.setErrors?.({});
				return localErrors;
			} catch (err) {
				if (err instanceof Yup.ValidationError) {
					err.inner.forEach((error) => {
						if (error.path) {
							localErrors[error.path] = error.message;
						}
					});
					props.setErrors?.({ ...localErrors });
				}
				return localErrors;
			}
		}, [info, props, validationSchema]);

		return (
			<div>
				{isLoaded ? (
					<div>
						<Box sx={{ width: "100%" }}>
							<TextField
								onChange={(event) => {
									const v = event.target.value ?? "";
									const newInfo = { ...info, departmentName: v };
									setInfo(newInfo);
									if (props.contact && props.setContact) {
										props.setContact({
											...props.contact,
											additionalInformation: [
												...(props.contact.additionalInformation?.filter(
													(ai) =>
														(ai as DepartmentInformation).__typename !== "DepartmentInformation",
												) ?? []),
												newInfo,
											],
										});
									}
								}}
								sx={{ width: "100%" }}
								value={info.departmentName}
								label={t("department-information.department")}
							/>
						</Box>
					</div>
				) : (
					<Loader />
				)}
			</div>
		);
	},
);

DepartmentInfo.displayName = "DepartmentInfo";
export default DepartmentInfo;
